import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { JsonApiDecorator } from '../json-api/JsonApiDecorator.js';
import camelCase from 'lodash/camelCase.js';
import upperFirst from 'lodash/upperFirst.js';

var buildGenericProps = function buildGenericProps(state, type, include) {
  var _apiStore$type, _state$api$type;

  var metaEntities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var apiStore = new JsonApiDecorator(state.api);
  var props;
  var collection = ((_apiStore$type = apiStore[type]) === null || _apiStore$type === void 0 ? void 0 : _apiStore$type.all(include)) || [];
  var collectionMeta = (_state$api$type = state.api[type]) === null || _state$api$type === void 0 ? void 0 : _state$api$type.meta;
  props = _defineProperty(_defineProperty(_defineProperty({
    collection: collection
  }, type, collection), "collectionMeta", collectionMeta), "".concat(type, "Meta"), collectionMeta);
  metaEntities === null || metaEntities === void 0 || metaEntities.forEach(function (entity) {
    var _state$api$entity;

    return props["".concat(entity, "Meta")] = (_state$api$entity = state.api[entity]) === null || _state$api$entity === void 0 ? void 0 : _state$api$entity.meta;
  });
  props.showAlertMessage = true;

  if (state.api.currentEntityId && state.api.currentEntityId !== 'add') {
    var _apiStore$type2;

    props.currentEntity = (_apiStore$type2 = apiStore[type]) === null || _apiStore$type2 === void 0 ? void 0 : _apiStore$type2.find(state.api.currentEntityId, include);
    props.showAlertMessage = false;
  }

  var _state$api = state.api,
      activePage = _state$api.activePage,
      activeFilters = _state$api.activeFilters,
      activeSort = _state$api.activeSort,
      activeSearch = _state$api.activeSearch,
      activeState = _state$api.activeState;
  props = _objectSpread2(_objectSpread2({}, props), {}, {
    activePage: activePage,
    activeFilters: activeFilters,
    activeSort: activeSort,
    activeSearch: activeSearch,
    activeState: activeState
  });

  if (state.api.currentEntityId === 'add') {
    props.currentEntity = apiStore.newObject(type);
    props.showAlertMessage = false;
  }

  if (!props.currentEntity && state.api.currentEntity) {
    props.currentEntity = state.api.currentEntity;
  }

  var loadingEntities = state.api.loadingEntities;

  if (loadingEntities) {
    Object.keys(loadingEntities).forEach(function (key) {
      props["isLoading".concat(upperFirst(camelCase(loadingEntities[key])))] = true;
    });
    props.isLoadingData = Object.values(loadingEntities).includes(type);
  }

  props.errorMessage = state.api.errorMessage;
  props.errorMessages = state.api.errorMessages;
  props.successMessage = state.api.successMessage;
  props.downloadProcessing = state.api.downloadProcessing;
  props.downloadUrl = state.api.downloadUrl;
  props.downloadTimedOut = state.api.downloadTimedOut;
  return props;
};

export { buildGenericProps };